import Service from "../../../Service";
import Axios from "../../../Config/API";
import {
    IConfigEnvelopeDestinatario,
    IInserirConfigEnvelopeDestinatario,
} from "../../../../Interfaces/Geral/ConfigEnvelope/ConfigEnvelopeDestinatario/ConfigEnvelopeDestinatarioInterfaces";

export async function GetConfigEnvelopeDestinatarioService(
    idConfigEnvelopeDest: number
) {
    return Service(
        Axios.get<IConfigEnvelopeDestinatario>(
            `/home/configenvelope/getconfigenvelopedest?idConfigEnvelopeDest=${idConfigEnvelopeDest}`
        )
    );
}

export async function ListarConfigEnvelopeDestinatarioService(
    idConfigEnvelope: number
) {
    return Service(
        Axios.get<Array<IConfigEnvelopeDestinatario>>(
            `/home/configenvelope/listarconfigenvelopedest?idConfigEnvelope=${idConfigEnvelope}`
        )
    );
}

export async function InserirConfigEnvelopeDestinatarioService(
    configEnvelopeDestinatario: IInserirConfigEnvelopeDestinatario
) {
    return Service(
        Axios.post(
            `/home/configenvelope/inserirenvelopeconfigdest`,
            configEnvelopeDestinatario
        )
    );
}

export async function DeletarConfigEnvelopeDestinatarioService(
    IdConfigEnvelopeDest: number
) {
    return Service(
        Axios.delete(
            `/home/configenvelope/deletaconfigenvelopedest?IdConfigEnvelopeDest=${IdConfigEnvelopeDest}`
        )
    );
}

export async function AtualizarConfigEnvelopeDestinatarioService(
    configEnvelopeDestinatario: IConfigEnvelopeDestinatario
) {
    return Service(
        Axios.put(
            `/home/configenvelope/atualizaconfigenvelopedest`,
            configEnvelopeDestinatario
        )
    );
}
